import { defineMessages } from "@/i18n";
import en from "./en";

export const framesCalendarMessages = defineMessages("frames-calendar", en);
